import React from 'react';
import styled from 'styled-components';
import { getAppVersion } from '../serviceWorkerRegistration';

const PoweredByContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 20px 0;
  padding: 10px 0;
  color: ${({ theme }) => theme.colors.textSecondary};
  font-size: 0.8rem;
  text-align: center;
  
  img {
    height: 25px;
    margin-bottom: 8px;
  }
  
  @media (max-width: 768px) {
    img {
      height: 20px;
    }
  }
`;

const VersionText = styled.div`
  margin-top: 5px;
  font-size: 0.7rem;
  opacity: 0.8;
`;

const PoweredBy: React.FC = () => {
  return (
    <PoweredByContainer>
      <img
        src="/images/powered-by.png"
        alt="Powered by"
      />
      <VersionText>v{getAppVersion()}</VersionText>
    </PoweredByContainer>
  );
};

export default PoweredBy;
